const initialState = {
  data: null,
  loading: null,
};

export default initialState;
